import { FilterConfiguration, FilterConfigurationType, FilterOption } from '@infuse/ui/domain';
import { FilterExpression } from '@infuse/api/common';
import { MessageType } from '@infuse/api/e-connector/message';
import { Ocpp1xMessageAction } from '@infuse/cpms/charging-station/store';

const PREDEFINED_TYPES: string[] = Object.values(MessageType);
const PREDEFINED_VERSIONS: string[] = ['1.5', '1.6'];
const PREDEFINED_ACTIONS: string[] = Object.values(Ocpp1xMessageAction);

const toOptions = (values: string[], label?: (value: string) => string): FilterOption[] =>
  values
    .filter((v) => !!v)
    .sort()
    .map((v) => ({
      name: v,
      label: () => (label ? label(v) : v),
      toUmbrellaExpression: () => new FilterExpression()
    }));

// the charging station and central system filters are always present; their
// options fill in as the (async) charging station and central system lists load
export const createMessageFilterConfigs = (
  t: (key: string) => string,
  chargingStationNames: string[],
  centralSystemNames: string[]
): FilterConfiguration[] => [
  {
    name: 'types',
    label: () => t('e_connector.messages.filters.type'),
    type: FilterConfigurationType.SELECT,
    options: toOptions(PREDEFINED_TYPES, (v) => t(`e_connector.messages.filterOptions.type.${v}`))
  },
  {
    name: 'versions',
    label: () => t('e_connector.messages.filters.version'),
    type: FilterConfigurationType.SELECT,
    options: toOptions(PREDEFINED_VERSIONS)
  },
  {
    name: 'actions',
    label: () => t('e_connector.messages.filters.action'),
    type: FilterConfigurationType.SELECT,
    options: toOptions(PREDEFINED_ACTIONS)
  },
  {
    name: 'chargePoints',
    label: () => t('e_connector.messages.filters.chargingStation'),
    type: FilterConfigurationType.SEARCH_SELECT,
    options: toOptions(chargingStationNames)
  },
  {
    name: 'centralSystems',
    label: () => t('e_connector.messages.filters.centralSystem'),
    type: FilterConfigurationType.SEARCH_SELECT,
    options: toOptions(centralSystemNames)
  }
];
